import React, { useState, useEffect } from 'react';
import { OnboardingStepProps } from '../../../types/onboarding';
import { Interest } from '../../../components/Profile/types';
import { InterestSelector } from '../../../components/Profile/InterestSelector';
import { StepTitle, StepDescription, StepContent } from '../../../styles/onboarding/Onboarding.styles';

const MIN_INTERESTS = 3;

export const InterestsStep: React.FC<OnboardingStepProps> = ({
  data,
  onChange,
  onSkip
}) => {
  const [interests, setInterests] = useState<Interest[]>(data?.interests || []);

  useEffect(() => {
    const isValid = interests.length >= MIN_INTERESTS;
    onChange({ interests }, isValid);
  }, [interests]);

  const handleInterestsChange = (updatedInterests: Interest[]) => {
    setInterests(updatedInterests);
  };

  return (
    <>
      <StepTitle>Select Your Interests</StepTitle>
      <StepDescription>
        Choose at least {MIN_INTERESTS} interests to help others discover you.
      </StepDescription>
      <StepContent>
        <InterestSelector
          interests={interests}
          onChange={handleInterestsChange}
        />
      </StepContent>
    </>
  );
};

